export enum SourceEnum {
  SLP = 'SLP',
  MANUAL_15_MINUTES = 'manual15mins',
  WATTLINE = 'wattline',
  ENOMETRIK = 'enometrik',
  SMA = 'sma',
  MAKO = 'mako',
  AMPECT = 'ampect',
  LINEMETRICS = 'linemetrics',
  MQTT = 'mqtt',
  VIRTUAL = 'virtual',
  DEMO = 'demo',
  API = 'api',
}

export const getSourceLabel = (source?: string | null): string => {
  const s = (source ?? '').toString().trim()
  if (!s || s === '-') return ''

  switch (s) {
    case SourceEnum.WATTLINE:
      return 'Wattline'
    case SourceEnum.ENOMETRIK:
      return 'Enometrik'
    case SourceEnum.SMA:
      return 'SMA'
    case SourceEnum.MAKO:
      return 'MaKo'
    case SourceEnum.AMPECT:
      return 'Ampect'
    case SourceEnum.LINEMETRICS:
      return 'Linemetrics'
    case SourceEnum.MQTT:
      return 'MQTT'
    case SourceEnum.VIRTUAL:
      return 'Virtuell'
    case SourceEnum.DEMO:
      return 'Demo'
    case SourceEnum.API:
      return 'API'
    case SourceEnum.SLP:
      return 'SLP'
    case SourceEnum.MANUAL_15_MINUTES:
      return 'Manuelle 15 Minuten'
    default:
      return s
  }
}
